import { RowDescriptor } from './row-descriptor';
import { RowsDescriptor } from './rows-descriptor';
import { RowsDescriptorType } from './rows-descriptor-type';
import { SelectAllState } from './select-all-state';

export class UpdateRowsDescriptor<TData, TId> extends RowsDescriptor {
  constructor(
    public data: RowDescriptor<TData, TId>[],
    public offset: number,
    public totalCount: number,
    public totalSelected: number,
    public selectAllState: SelectAllState,
    public disabled = false
  ) {
    super(RowsDescriptorType.Update);
  }
}
